import { tx } from "../lib/i18n";
import { useEffect, useRef, useState } from "react";
import DailyIframe from "@daily-co/daily-js";
import { MonitorUp, PhoneOff, VideoOff, User } from "lucide-react";

// Embeds Daily Prebuilt. Without a Daily API key, shows a test-mode room and still records join/leave.
export const LiveRoom = ({ access, name, onEvent, onLeave }) => {
  const ref = useRef(null);
  const sent = useRef(false);
  const [left, setLeft] = useState(false);

  useEffect(() => {
    if (!access) return;
    const leave = (beacon) => { if (sent.current) { sent.current = false; onEvent("left", beacon); } };
    const onHide = () => leave(true);
    window.addEventListener("pagehide", onHide);
    if (access.test_mode) {
      const timer = setTimeout(() => { sent.current = true; onEvent("joined"); }, 400);
      return () => { clearTimeout(timer); window.removeEventListener("pagehide", onHide); leave(); };
    }
    const call = DailyIframe.createFrame(ref.current, {
      iframeStyle: { width: "100%", height: "100%", border: "0", borderRadius: "16px" },
      showLeaveButton: true,
    });
    call.on("joined-meeting", () => { sent.current = true; onEvent("joined"); });
    call.on("left-meeting", () => { leave(); setLeft(true); onLeave?.(); });
    call.join({ url: access.room_url, token: access.token }).catch(console.error);
    return () => { window.removeEventListener("pagehide", onHide); leave(); call.destroy(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  if (left) return <div className="flex h-full items-center justify-center rounded-2xl bg-osk-navy text-white">{tx("Je hebt de les verlaten.")}</div>;
  if (access?.test_mode) return (
    <div className="flex h-full flex-col rounded-2xl bg-osk-navy p-5 text-white" data-testid="live-room-test-mode">
      <div className="mb-4 flex items-center justify-between">
        <span className="osk-pill bg-osk-orange text-white">{tx("TESTMODUS – Daily API-sleutel nog niet ingesteld")}</span>
        <span className="text-xs text-white/60">{tx("Opnemen uitgeschakeld")}</span>
      </div>
      <div className="grid flex-1 gap-4 sm:grid-cols-2">
        <div className="flex flex-col items-center justify-center rounded-xl bg-white/10"><User className="h-16 w-16 text-white/50" /><p className="mt-2 text-sm font-semibold">{name} {tx("(jij)")}</p></div>
        <div className="flex flex-col items-center justify-center rounded-xl bg-white/5"><VideoOff className="h-12 w-12 text-white/30" /><p className="mt-2 text-xs text-white/60">{tx("Hier verschijnt de Daily Prebuilt video")}</p></div>
      </div>
      <div className="mt-4 flex justify-center gap-3">
        <button className="osk-btn bg-white/10 px-5 py-2.5 text-white" disabled><MonitorUp className="h-4 w-4" />{tx("Scherm delen")}</button>
        <button className="osk-btn bg-osk-red px-5 py-2.5 text-white" onClick={() => { if (sent.current) { sent.current = false; onEvent("left"); } setLeft(true); onLeave?.(); }} data-testid="live-room-leave-btn"><PhoneOff className="h-4 w-4" />{tx("Les verlaten")}</button>
      </div>
    </div>
  );
  return <div ref={ref} className="h-full w-full" data-testid="live-room-daily" />;
};
